import { FC, useState } from 'react';

import CommonButton from 'components/CommonButton/CommonButton';
import DefaultModal from 'components/Modals/DefaultModal';

import useOverrideModal from 'hooks/useOverrideModal';

import ServiceScheduleException from 'interfaces/serviceScheduleException';
import OverrideModalBody from './OverideModalBody/OverideModalBody';

export interface OverwriteOption extends ServiceScheduleException {
  id: string;
  checked: boolean;
}

interface OverrideModalProps {
  exceptionsDates: ServiceScheduleException[];
  onClose: () => void;
  onOverwrite: (arg: OverwriteOption[]) => void;
}

const OverrideModal: FC<OverrideModalProps> = ({
  exceptionsDates,
  onClose,
  onOverwrite,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    options,
    selectAllRef,
    handleChangeCheckbox,
    handleChangeSelectAll,
    totalSelectOptions,
  } = useOverrideModal(
    exceptionsDates.map((exception) => ({
      id: `${exception.date}-${exception.serviceId}-${exception.serviceId}`,
      ...exception,
    }))
  );

  const onSubmit = async () => {
    setIsSubmitting(true);
    await onOverwrite(options);
    setIsSubmitting(false);
  };

  // const handleOnSubmit = async () => {
  //   setIsSubmitting(true);
  //   setIsAllowed(false);

  //   const filterCheckedOptions = options.filter((option) => option.checked);

  //   const body = filterCheckedOptions.map((option) => {
  //     const day = changedTimeSlots.find(
  //       (timeSlot) =>
  //         moment(option.date, 'YYYY-MM-DD').day() ===
  //         moment(capitalize(timeSlot.day), 'ddd').day()
  //     )!;

  //     return {
  //       id: option.id,
  //       date: option.date,
  //       isClosed: !day.start && !day.end,
  //       isHoliday: false,
  //       shifts: [
  //         {
  //           start: day.start,
  //           end: day.end,
  //         },
  //       ],
  //     };
  //   });

  //   try {
  //     await onUpdateSchedule();

  //     if (body.length > 0) {
  //       await axiosInstance.patch('/clinics-exception', body, {
  //         params: {
  //           source,
  //         },
  //         headers: {
  //           version,
  //         },
  //       });
  //     }

  //     await Promise.all([
  //       matchMutate(/\/clinics-schedule[\s\S]+/),
  //       matchMutate(/\/clinics-exception[\s\S]+/),
  //     ]);

  //     await onCheckOutsideOfficeHourAppts();
  //     renderToast({
  //       type: 'success',
  //       message: 'Regular hours has been updated successfully',
  //     });

  //     setIsAllowed(true);
  //     onClose();
  //   } catch (error) {
  //     if (axios.isAxiosError(error) && error.response?.status === 409) {
  //       return setIsOldVersion(true);
  //     }

  //     renderToast({
  //       message: 'Something went wrong. Please try again later',
  //       type: 'error',
  //     });
  //     setIsSubmitting(false);
  //   }
  // };

  return (
    <DefaultModal>
      <div className="max-h-[50.2rem] pt-2 pb-2.9 px-2 text-darkest-grey text-14 leading-[2.1rem]">
        <h3 className="font-bold text-20 leading-[3rem]">
          Override these custom days?
        </h3>
        <span className="mt-0.8">
          Unselect the days you would like to keep as custom
        </span>
        <OverrideModalBody
          options={options}
          selectAllRef={selectAllRef}
          handleChangeSelectAll={handleChangeSelectAll}
          handleChangeCheckbox={handleChangeCheckbox}
          totalSelectOptions={totalSelectOptions}
        />

        <div className="flex justify-end gap-x-1.6 mt-2.5">
          <CommonButton
            variant="secondary"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </CommonButton>
          <CommonButton isLoading={isSubmitting} onClick={onSubmit}>
            Confirm
          </CommonButton>
        </div>
      </div>
    </DefaultModal>
  );
};

export default OverrideModal;
